import {useCallback} from 'react';

import {useRecaptchaContext} from '../components/ReCaptcha/RecaptchaProvider';
import {recaptchaLogger} from '../utils/recaptchaMonitoring';

import {useRecaptchaConfig} from './useRecaptchaConfig';

/**
 * Hook para proteção de endpoints com reCAPTCHA v3
 * Segue padrões de grandes empresas para reutilização e manutenibilidade
 */
export const useRecaptchaProtection = () => {
  const {executeRecaptcha} = useRecaptchaContext();
  const {config} = useRecaptchaConfig();

  const executeWithProtection = useCallback(
    async (apiCall, action, payload = {}) => {
      try {
        let recaptchaToken = null;

        if (config.ENABLED) {
          recaptchaToken = await executeRecaptcha(action);

          if (!recaptchaToken) {
            recaptchaLogger.warn('Token reCAPTCHA não gerado', {action});
          }
        }

        const result = await apiCall(payload, recaptchaToken);

        recaptchaLogger.info('API call protegida executada com sucesso', {
          action,
          hasToken: !!recaptchaToken
        });

        return result;
      } catch (error) {
        recaptchaLogger.error('Erro na proteção reCAPTCHA', {
          action,
          error: error.message,
          stack: error.stack
        });
        throw error;
      }
    },
    [executeRecaptcha, config]
  );

  return {
    executeWithProtection
  };
};

export default useRecaptchaProtection;
